const productswiper = new Swiper('.product-swiper', {
    // 前後の矢印
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    spaceBetween: 20,
    // アイテムの左右はみだし
    slidesPerView: 2.5,
      scrollbar: {
        el: '.slider__scrollbar',
        draggable: true,
        dragSize: 200,
        snapOnRelease: false,
        dragClass: 'slider__btn',
      },
  grid: {
    rows: 2,
  },
      breakpoints: {
        // スライドの表示枚数：679px以上の場合
          679: {
            slidesPerView: 'auto',
            grid: {
              rows: 1,
            },
            spaceBetween: 40,
            slidesPerView: 4.3,
          }
        }
  });

const mvSwiper2 = new Swiper('.mv-swiper', {
    loop:true,
 　　 lazy: true,
    spaceBetween: 10,
    centeredSlides: true,
    //slidesPerView: 2.1,
    // アイテムの左右はみだし
    slidesPerView: 'auto',
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    lazy: {
      loadPrevNext: true,
    },
    autoplay: {
      delay: 5000, // 5秒ごとにスライド
      disableOnInteraction: false,
    },
    navigation: { // 矢印ナビゲーションを追加
      nextEl: '.swiper-mv-button-next',
      prevEl: '.swiper-mv-button-prev',
    },
    breakpoints: {
      // スライドの表示枚数：679px以上の場合
        679: {
    spaceBetween: 40,
        }
      },
  });


const featuredswiper = new Swiper('.featured-swiper', {
    spaceBetween: 20,
    // アイテムの左右はみだし
    slidesPerView: 'auto',
    slidesPerView: 2,
    grid: {
      rows: 2,
    },
      scrollbar: {
        el: '.slider__scrollbar',
        draggable: true,
        dragSize: 200,
        snapOnRelease: false,
        dragClass: 'slider__btn',
      },
      breakpoints: {
        // スライドの表示枚数：679px以上の場合
          679: {
            slidesPerView: 'auto',
            grid: {
              rows: 1,
            },
           slidesPerView: 4,
          }
        },
  });


const rankswiper = new Swiper('.rank-swiper', {
    // 前後の矢印
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    spaceBetween: 20,
    // アイテムの左右はみだし
    slidesPerView: 2.5,
      scrollbar: {
        el: '.slider__scrollbar',
        draggable: true,
        dragSize: 200,
        snapOnRelease: false,
        dragClass: 'slider__btn',
      },
      breakpoints: {
        // スライドの表示枚数：679px以上の場合
          679: {
            slidesPerView: 'auto',
            grid: {
              rows: 1,
            },
            spaceBetween: 40,
            slidesPerView: 4.3,
          }
        }
  });

const pastswiper = new Swiper('.past-swiper', {
    spaceBetween: 10,
    // 前後の矢印
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    spaceBetween: 20,
    // アイテムの左右はみだし
    slidesPerView: 2.5,
      scrollbar: {
        el: '.slider__scrollbar',
        draggable: true,
        dragSize: 200,
        snapOnRelease: false,
        dragClass: 'slider__btn',
      },
  grid: {
    rows: 2,
  },
      breakpoints: {
        // スライドの表示枚数：679px以上の場合
          679: {
            slidesPerView: 'auto',
            grid: {
              rows: 1,
            },
            spaceBetween: 40,
            slidesPerView: 4.3,
          }
        }
  });


  // mvスライダーのフェードインアニメーション
//  const slider = document.querySelector('.mv-top-Slider');
  //slider.style.opacity = 0;
  //window.addEventListener('load', () => {
    //setTimeout(() => {
     // slider.style.transition = 'opacity 0.3s';
   //   slider.style.opacity = 1;
 //   }, 100);
//  });



$(document).ready(function () {
    // アコーディオンの処理
    $(".accordion_header").click(function (event) {
        event.stopPropagation();
        $(this).next(".accordion_inner").slideToggle();
        $(this).toggleClass("open");
        return false;
    });
});



const productswiper2 = new Swiper('.product-swiper-ver2', {
  // 前後の矢印
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  spaceBetween: 20,
  // アイテムの左右はみだし
  slidesPerView: 2.5,
    scrollbar: {
      el: '.slider__scrollbar',
      draggable: true,
      dragSize: 200,
      snapOnRelease: false,
      dragClass: 'slider__btn',
    },
grid: {
  rows: 1,
},
    breakpoints: {
      // スライドの表示枚数：679px以上の場合
        679: {
          slidesPerView: 'auto',
          grid: {
            rows: 1,
          },
          spaceBetween: 40,
          slidesPerView: 4.3,
        }
      }
});
